import IdTokenVerifier from 'idtoken-verifier';

function selectUserPermission(state) {
  const userPermissions = state.general.auth.userPermissions;

  // When userPermissions is already in redux state, use it
  // This can be achieved when using AWS Cognito
  if (userPermissions.length > 0) {
    return userPermissions;
  }

  const accessToken = state.general.auth.accessToken;
  if (!accessToken) {
    return [];
  }

  const verifier = new IdTokenVerifier();
  const { payload } = verifier.decode(accessToken);
  return Array.from(
    new Set(
      (payload['https://traveloka/permission'] || []).concat(
        payload.permissions || []
      )
    )
  );
}

export default selectUserPermission;
